import { cva } from 'class-variance-authority';

/**
 * Button styles for the Button component.
 */
export const buttonStyles = cva(
    'flex flex-row font-semibold rounded-[8px] gap-x-2 disabled:cursor-not-allowed items-center justify-center',
    {
        variants: {
            variant: {
                primary:
                    'bg-primary500 text-white border-primary500 hover:bg-opacity-90 hover:shadow-primary disabled:bg-primary200 disabled:bg-opacity-50',
                primaryInvert:
                    'bg-primary100 text-primary700 border-primary500 hover:bg-opacity-90 hover:shadow-primary disabled:bg-primary200 disabled:bg-opacity-50',
                secondaryOutline:
                    'bg-white text-gray700 border border-gray hover:border-gray hover:bg-offWhite',
                secondary:
                    'bg-primary50 text-primary700 hover:shadow-secondary disabled:bg-primary25 disabled:text-primary300',
                tertiaryOutline:
                    'bg-none text-gray200 hover:bg-offWhite disabled:text-gray',
                tertiary:
                    'bg-none text-primary700 hover:bg-primary50 disabled:text-gray',
                error: 'bg-red500 text-white hover:bg-opacity-90 hover:shadow-error disabled:bg-red50 disabled:bg-opacity-50',
                errorOutline:
                    'bg-none text-red600 border border-red25 hover:bg-opacity-90 hover:shadow-error disabled:text-red25 disabled:border-opacity-50',
                errorNoOutline: '',
                errorSecondary:
                    'bg-provincialPink text-red600 hover:bg-opacity-90 hover:shadow-error disabled:text-red25 disabled:border-opacity-50'
            },
            size: {
                sm: ['text-sm font-medium leading-[20px] h-[36px] px-[14px]'],
                md: ['text-sm h-[40px] px-[16px]'],
                lg: ['text-base h-[44px] px-[18px]'],
                xl: ['text-base h-[48px] px-[20px]'],
                xxl: ['text-lg h-[60px] px-[28px]']
            }
        },
        compoundVariants: [
            {
                variant: 'primary',
                size: 'md'
            }
        ],
        defaultVariants: {
            variant: 'primary',
            size: 'md'
        }
    }
);
